module.exports = __webpack_public_path__ + "img/bb_g3_t_antenna-02.11dd7d57.svg";